import client from "./client";

export const deviceSummary = ({ diag_t_id }) => {
  let form = client.get(`/diagnosis/api/result/device/summary/${diag_t_id}`);
  return form;
};

export const publicSummary = ({ token }) => {
  let form = client.get(`/diagnosis/api/result/summary/${token}`);
  return form;
};

export const publicPaper = ({ token }) => {
  let form = client.get(`/diagnosis/api/result/paper/${token}`);
  return form;
}

export const summary = ({ solved_problems, achieve }) => {
  let summary = client.post("/diagnosis/api/result/summary", {
    solved_problems,
    achieve,
  });
  return summary;
};

export const achievement = ({ solved_problems, achieve }) => {
  let achievement = client.post("/diagnosis/api/result/achievement", {
    solved_problems,
    achieve,
  });
  return achievement;
};
